import {
  S3Client,
  PutObjectCommand,
  DeleteObjectCommand,
} from "@aws-sdk/client-s3";
import { v4 as uuidv4 } from "uuid";
import { getKeysRequest } from "./auth-service";
import logger from "main/shared/logger";

export const updateAWS = async () => {
  const keys = await getKeysRequest();

  return new S3Client({
    region: "us-east-1",
    credentials: {
      accessKeyId: keys.data.key,
      secretAccessKey: keys.data.value,
    },
  });
};

// 🔹 Upload file to S3
export const uploadToS3 = async (file, directory = "") => {
  try {
    const s3 = await updateAWS();

    const temp = file.name.split(".");
    const fileExt = temp[temp.length - 1];
    const fileName = `${directory}${uuidv4()}.${fileExt}`;

    const fileBuffer = await file.arrayBuffer();

    const params = {
      Bucket: process.env.REACT_APP_S3_BUCKET,
      Key: fileName,
      Body: fileBuffer,
      ContentType: file.type,
      ACL: "public-read",
    };

    const command = new PutObjectCommand(params);
    const response = await s3.send(command);

    return {
      ...response,
      url: `https://${process.env.REACT_APP_S3_BUCKET}.s3.amazonaws.com/${fileName}`,
    };
  } catch (error) {
    logger.error("❌ S3 Upload failed:", error);
    throw error;
  }
};

// 🔹 Delete file from S3 by URL
export const deleteFromS3 = async (url) => {
  try {
    const s3 = await updateAWS();
    const parts = url.split("/");
    const Key = parts[parts.length - 1];

    const params = {
      Bucket: process.env.REACT_APP_S3_BUCKET,
      Key,
    };

    const command = new DeleteObjectCommand(params);
    const response = await s3.send(command);

    return response;
  } catch (error) {
    logger.error("❌ Delete failed:", error);
    throw error;
  }
};
